import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import storageService from '../../../utils/storageService';
import AmenityTypeList from './components/AmenityTypeList';
import AmenityMasterList from './components/AmenityMasterList';
import AmenityBookingsList from './components/AmenityBookingsList';
import AmenityReports from './components/AmenityReports';
import PageHeadingSection from '../pageheading/PageHeadingSection';
import Breadcrumbs from '../BreadCrum/BreadCrum';

const tabs = [
    { id: 'TYPES', label: 'Amenity Types' },
    { id: 'MASTER', label: 'Amenity Master' },
    { id: 'BOOKINGS', label: 'Bookings' },
    { id: 'REPORTS', label: 'Reports' },
];

const AmenitiesModule = () => {
    const { user: authUser } = useSelector((state) => state.auth);
    const [activeTab, setActiveTab] = useState('TYPES');

    // Fetching the dynamic siteId from the logged-in user's session
    const storedSiteId = authUser?.siteId || authUser?.SiteId || Number(storageService.getItem("siteId")) || 0;

    const renderContent = () => {
        switch (activeTab) {
            case 'TYPES':
                return <AmenityTypeList siteId={storedSiteId} authUser={authUser} />;
            case 'MASTER':
                return <AmenityMasterList siteId={storedSiteId} authUser={authUser} />;
            case 'BOOKINGS':
                return <AmenityBookingsList siteId={storedSiteId} authUser={authUser} />;
            case 'REPORTS':
                return <AmenityReports siteId={storedSiteId} authUser={authUser} />;
            default:
                return <AmenityTypeList siteId={storedSiteId} authUser={authUser} />;
        }
    };

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto gap-4 pt-4">
            <Breadcrumbs />
            
            <PageHeadingSection
                mainHeading="Amenities Management"
                subHeading="Manage amenity types, create master records, and track bookings."
            />
            
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex-1 flex flex-col shrink-0">
                {/* Tabs */}
                <div className="border-b border-gray-200">
                    <nav className="flex -mb-px px-6" aria-label="Tabs">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`w-1/4 py-4 px-1 text-center border-b-2 font-medium text-sm transition-colors ${
                                    activeTab === tab.id
                                        ? 'border-indigo-500 text-indigo-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </nav>
                </div>

                {/* Tab Content */}
                <div className="p-6 overflow-y-auto flex-1 bg-white">
                    {renderContent()}
                </div>
            </div>
        </div>
    );
};

export default AmenitiesModule;
